/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Link } from "cms/components/components/icon-links-list/display/link";
import { Icon } from "cms/components/components/icon-links-list/display/icon";

const IconListItemCard = (props) => {
    
    const { icon_link, index, settings } = props;
    const { style, format } = settings || {};
    
    if (!icon_link) {
        return null;
    } else {
        return (
            <div className='link-list-item'
                style={{ display: "flex", flexDirection: "row", gap: "12px" }}
            >
                <div>
                    <Icon icon={icon_link?.icon}/>
                </div>
                <Link
                    index={index}
                    link={icon_link.link}
                    style={style}
                    format={format}
                />
            </div>
        );
    }
};

export { IconListItemCard };
